<template>
  <div id="app">
    <el-container>
      <el-header> <home-header></home-header> </el-header>
      <el-main> <router-view/> </el-main>
      <el-footer class="footer"> <home-footer></home-footer> </el-footer>
    </el-container>
  </div>
</template>

<script>
import HomeHeader from '@/pages/Header/Header'
import HomeFooter from '@/pages/Footer/Footer'
export default {
  name: 'App',
  components: {
    HomeHeader: HomeHeader,
    HomeFooter: HomeFooter
  }
}
</script>

<style scoped>
.footer{
  background-color: white;
  height: 66px;
  /* 这里使用 fixed 就会固定在底部, 如果使用 flex 则会进行浮动 */
  position: fixed;
  bottom: 0;
  width: 100vw;
}
</style>



// WEBPACK FOOTER //
// src/App.vue